import React from "react";
import "./ui.scss";

/**
 * tone: "primary" | "success" | "warning" | "danger"
 * `loading` shows a skeleton in place of the value so the layout doesn't jump.
 */
const SummaryCard = ({
  icon,
  tone = "primary",
  label,
  value,
  hint,
  loading = false,
}) => (
  <div className={`hr-card hr-summary hr-summary--${tone}`}>
    <div className="stats-card__accent" aria-hidden="true" />
    <div className="hr-summary__icon" aria-hidden="true">
      {typeof icon === "string" ? (
        <span className="material-symbols-outlined">{icon}</span>
      ) : (
        icon
      )}
    </div>
    <div className="hr-summary__body">
      <div className="hr-summary__label">{label}</div>
      {hint && !loading && <div className="hr-summary__hint">{hint}</div>}
    </div>
    <div className="hr-summary__value">
      {loading ? <span className="hr-skeleton hr-skeleton--short" /> : value}
    </div>
  </div>
);

export default SummaryCard;
